module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "h2a"
  }, [_c('a', {
    attrs: {
      "id": "page_5"
    }
  }, [_vm._v("CONTENTS")])]), _c('a', {
    attrs: {
      "id": "page_5"
    }
  }), _c('h2', {
    staticClass: "toc-chap1"
  }, [_c('a', {
    attrs: {
      "id": "page_5"
    }
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/04_Acknowledgements"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Acknowledgements")])])]), _vm._v(" "), _c('h2', {
    staticClass: "toc-chap"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/06_Preface"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Preface")])])]), _vm._v(" "), _c('h2', {
    staticClass: "toc-chap"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/08_Chapter_01"
    }
  }, [_c('span', {
    staticClass: "toc-chap_float"
  }, [_vm._v("Chapter 1")]), _vm._v(" Ogmore Branch – Tondu to Nantymoel")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/09_Chapter_02",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "toc-chap_float"
  }, [_vm._v("Chapter 2")]), _vm._v(" Garw Branch – Brynmenyn to Blaengarw")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/10_Chapter_03",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "toc-chap_float"
  }, [_vm._v("Chapter 3")]), _vm._v(" Porthcawl Branch – Tondu to Porthcawl")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/11_Chapter_04",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "toc-chap_float"
  }, [_vm._v("Chapter 4")]), _vm._v(" Gilfach Goch Branch")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/12_Chapter_05",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "toc-chap_float"
  }, [_vm._v("Chapter 5")]), _vm._v(" Llanharan Branch")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/13_Chapter_06",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "toc-chap_float"
  }, [_vm._v("Chapter 6")]), _vm._v(" Enthusiast Specials")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/14_Chapter_07",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "toc-chap_float"
  }, [_vm._v("Chapter 7")]), _vm._v(" Main Line Diversions")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/15_Chapter_08",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "toc-chap_float"
  }, [_vm._v("Chapter 8")]), _vm._v(" Chronologies")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc-chaps"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/15_Chapter_08#ch08_s1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Saturday 7 July 1962 Tondu to Porthcawl")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc-chaps"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/15_Chapter_08#ch08_s2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Saturday 3 May 1958 Last Passenger Services to Nantymoel")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1318eeb7","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/Toc.vue
// module id = 66
// module chunks = 0